import React from 'react';
import './progressBar.css'; // Import your custom CSS

const ProgressBar = ({ percentage }) => {
    console.log(percentage)
  return (
    <div className="progress-container-div">
    <div className="progress-bar">
        <div className="progress-fill" style={{ width: `${percentage}%` }}></div>
    </div>
    <span className="percentage-text">{percentage}%</span>
</div>

  );
};

export default ProgressBar;
